import {openResourceModal} from '../../core/modalCommand';
import {
	SNMP_CONFIGURATION_CREATE_MODAL_EVENT,
	SNMP_CONFIGURATION_EDIT_MODAL_EVENT,
	SNMP_CONFIGURATION_DELETE_MODAL_EVENT,
} from './events';

/**
 * Open Add SNMP for the resolved row.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSnmpConfigurationCreateModal(command, envelope) {
	return openResourceModal(SNMP_CONFIGURATION_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open Edit SNMP for the resolved row.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSnmpConfigurationEditModal(command, envelope) {
	return openResourceModal(SNMP_CONFIGURATION_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open Delete SNMP for the resolved row.
 *
 * The confirmation, not the deletion. Nothing is removed until the
 * person presses the button inside it.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSnmpConfigurationDeleteModal(command, envelope) {
	return openResourceModal(SNMP_CONFIGURATION_DELETE_MODAL_EVENT, command, envelope);
}
